import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosClient, ENDPOINTS } from "../../../services/common";

// GET PRODUCTS LISTS BEFORE LOGIN
export const getProductsBeforeLogin = createAsyncThunk(
  "filter-products-before-login",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.PRODUCTS_LIST_BEFORE_LOGIN,
        payload,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while sending a productslist request.",
      );
    }
  },
);
// GET NEAR BY PRODUCTS
export const getNearByProducts = createAsyncThunk(
  "get-products-by-lat-long",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.NEAR_BY_PRODUCTS,
        payload,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while sending a productslist request.",
      );
    }
  },
);

export const getNearByProductsBeforeLogin = createAsyncThunk(
  "get-products-by-lat-long-before-login",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.NEAR_BY_PRODUCTS_BEFORE_LOGIN,
        payload,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while sending a productslist request.",
      );
    }
  },
);

// select campaign and create new campaign post
export const createNewCampaign = createAsyncThunk(
  "auth/createCampaign",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.BUYER_CREATE_CAMPAIGN,
        payload,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "An error occurred while creating  campaign ",
      );
    }
  },
);

//buyer campaigns details
export const getBuyerCampaigns = createAsyncThunk(
  "campaigns-buyer",
  async ({ value, currentPage }, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.get(
        ENDPOINTS.BUYER_CAMPAINGS +
          `=${value}` +
          (currentPage !== undefined
            ? `&page_no=${currentPage}&page_size=${7}`
            : ""),
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while sending a productslist request.",
      );
    }
  },
);

//search buyer campaigns details
export const searchBuyerCampaigns = createAsyncThunk(
  "search-campaigns",
  async ({ value, searchdata }, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.get(
        ENDPOINTS.SEARCH_BUYER_CAMPAINGS + `/${searchdata}/${value}`,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while sending a productslist request.",
      );
    }
  },
);

//get userSavedCampigns

export const getUserSavedCampaigns = createAsyncThunk(
  "saved-campaigns",
  async (campaignId, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.get(ENDPOINTS.BUYER_SAVED_CAMPAIGNS);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while viewing campaign details",
      );
    }
  },
);

//Rename buyer campaign
export const renameCampaignName = createAsyncThunk(
  "rename-campaign",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.BUYER_EDIT_CAMPAIGN,
        payload,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while viewing campaign details",
      );
    }
  },
);

//share buyer campaign
export const shareCampaignDetails = createAsyncThunk(
  "share-campaign",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.BUYER_SHARE_CAMPAIGN,
        payload,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while viewing campaign details",
      );
    }
  },
);

//delete campaign from buyer campaigns
export const deleteCampaign = createAsyncThunk(
  "delete-campaign",
  async (campaignId, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.delete(
        ENDPOINTS.BUYER_DELETE_CAMPAIGN + `/${campaignId}`,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while viewing campaign details",
      );
    }
  },
);

//create a duplicate campaign
export const duplicateCampaign = createAsyncThunk(
  "duplicate-campaign",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.BUYER_DULICATE_CAMPAIGN,
        payload,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while viewing campaign details",
      );
    }
  },
);

//get buyer all campaigns

export const buyerCampaigns = createAsyncThunk(
  "campaign-details",
  async (campaignId, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.get(
        ENDPOINTS.BUYER_CAMPAIGN + `/${campaignId}`,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while viewing campaign details",
      );
    }
  },
);

//get AI recommneded products

export const aiRecommendedProducts = createAsyncThunk(
  "ai-recommended",
  async (campaignId, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.AI_RECOMMENDED_PRODUCTS,
        { campaign_id: campaignId },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while viewing campaign details",
      );
    }
  },
);

// Add campaign to cart
export const saveCampaignToCart = createAsyncThunk(
  "add-to-cart",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.post(ENDPOINTS.ADD_TO_CART, payload);

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while viewing campaign details",
      );
    }
  },
);

// get buyer cart details
export const cartDetails = createAsyncThunk(
  "campaign-cart-details",
  async (campaignCart, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(ENDPOINTS.CART_DETAILS);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while viewing campaign details",
      );
    }
  },
);

//increase product qty in campaign
export const updateProductQty = createAsyncThunk(
  "update-product-qty",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.UPDATE_PRODUCT_QUANTITY,
        payload,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while viewing campaign details",
      );
    }
  },
);

//increase product qty in campaign
export const deleteCampaignProduct = createAsyncThunk(
  "delete-campaign-product",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.delete(
        ENDPOINTS.BUYER_CAMPAIGN +
          `/${
            payload?.campaignId +
            "/product/" +
            payload?.productId +
            "/price/" +
            payload?.price
          }`,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while viewing campaign details",
      );
    }
  },
);

//submit gross fee
export const grossFeeRequest = createAsyncThunk(
  "gross-fee",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.BUYER_GROSS_FEE,
        payload,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while viewing campaign details",
      );
    }
  },
);
//request buyer offer

export const offerPriceRequest = createAsyncThunk(
  "offer-price",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.BUYER_OFFER_PRICE,
        payload,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while viewing campaign details",
      );
    }
  },
);
//
export const requestExternalSearch = createAsyncThunk(
  "request-external-search",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.BUYER_REQUEST_RESEARCH,
        payload,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while viewing campaign details",
      );
    }
  },
);
export const downloadRFPSearchCriteria = createAsyncThunk(
  "rfp-search-criteria-download",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.get(
        ENDPOINTS.BUYER_RFP_SEARCH_CRITERIA + `/${payload?.campaignId}`,
        {
          responseType: "blob",
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while viewing campaign details",
      );
    }
  },
);

// Get the selected columns to expoprt excel in campaign details page
export const getSelectedColumnsToExport = createAsyncThunk(
  "SelectedColsToExport",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.get(ENDPOINTS.SELECTED_COLS_EXPORT);
      return response.data;
    } catch (error) {
      const message =
        typeof error.response?.data == "string"
          ? error.response.data
          : error.response?.data?.message ||
            "An error occurred while exporting excel";
      return rejectWithValue(message);
    }
  },
);

// export excel
export const exportToExcel = createAsyncThunk(
  "excelExport",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.post(ENDPOINTS.EXPORT_EXCEL, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "An error occurred while exporting excel",
      );
    }
  },
);
// Payment receipt download
export const downloadInvoice = createAsyncThunk(
  "payments-info-download",
  async (payload, { rejectWithValue, getsState }) => {
    try {
      const response = await axiosClient.get(
        ENDPOINTS.PAYMENTS_DOWNLOAD + `/${payload}`,
        {
          responseType: "blob",
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "An error occured while downloading invoice ",
      );
    }
  },
);

// Buyer Payments List
export const getBuyerPaymentsList = createAsyncThunk(
  "payments-buyer",
  async ({ value, currentPage }, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.get(
        ENDPOINTS.BUYER_CAMPAINGS +
          `=${value}&page_no=${currentPage}&page_size=${currentPage * 8}`,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while sending a productslist request.",
      );
    }
  },
);

export const checkProductAvailabilityQuantity = createAsyncThunk(
  "product-availability-quantity",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.get(
        ENDPOINTS.PRODUCT_AVAILABILITY_QUANTITY +
          `/${payload?.productId}` +
          `/${payload?.dates}`,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while checking product availability quantity",
      );
    }
  },
);

export const checkProductAvailabilityQuantityBeforeLogin = createAsyncThunk(
  "product-availability-quantity-before-login",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.get(
        ENDPOINTS.PRODUCT_AVAILABILITY_QUANTITY_BEFORE_LOGIN +
          `/${payload?.productId}` +
          `/${payload?.dates}`,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while checking product availability quantity",
      );
    }
  },
);

//Get the campaign and products for the payment
export const getCampaignsForPurchase = createAsyncThunk(
  "get-campaign-payments",
  async (payload = {}, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(
        ENDPOINTS.GET_CAMPAIGNS_FOR_PURCHASE,
        {
          params: payload?.page_name
            ? {
                page_name: payload.page_name,
              }
            : {},
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred during getting the campaign for the proceed to purchase.",
      );
    }
  },
);

export const updateProductsExpiryTimeDocusign = createAsyncThunk(
  "update-products-expiry-time-docusign",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.UPDATE_PRODUCTS_EXPIRY_TIME_DOCUSIGN,
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while updating product expiry time.",
      );
    }
  },
);
//update checked and unchecked status for campaigns in cart
export const updateCheckedUnCheckedCart = createAsyncThunk(
  "update-checked-unchecked",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.UPDATE_CHECKED_UNCHECKED_CART,
        payload,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred during getting the campaign for the proceed to purchase.",
      );
    }
  },
);

// delete the camapign from the cart

export const deleteCampaignFromCart = createAsyncThunk(
  "delete-campaign-from-cart",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.delete(
        ENDPOINTS.BUYER_CAMPAIGN_DELETE_FROM_CART + `/${payload}`,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while deleting the campaign from the cart!",
      );
    }
  },
);

//upadate the terms of each campaigns
export const updateTermsToCampaigns = createAsyncThunk(
  "update-terms-to-campains",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.CAMPAINS_TERM_APPLY_UPDATE,
        payload,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "An error occurred during applying the terms.",
      );
    }
  },
);
export const deleteTermsFromCheckOut = createAsyncThunk(
  "delete-terms-from-checkout",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.delete(
        ENDPOINTS.DELETE_TERMS_FROM_CHECKOUT,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "An error occurred while deleting the terms !",
      );
    }
  },
);

//post product expiry notify api
export const productExpiryNotify = createAsyncThunk(
  "product-expiry-notify",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.PRODUCT_EXPIRY_NOTIFY,
        payload,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "An error occurred during applying the terms.",
      );
    }
  },
);

// Buyer Dashboard Campaigns Count
export const buyerDashboardCampaignsCount = createAsyncThunk(
  "buyer-status-campaigns-count",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.get(
        ENDPOINTS.BUYER_CAMPAIGNS_STATUS_COUNT,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occured while getting dashboard campaigns count",
      );
    }
  },
);

// Buyer Dashboard Campaigns Count
export const chequePayment = createAsyncThunk(
  "buyer-cheque-payment",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.post(ENDPOINTS.CHEQUE_PAYMENT);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "An error occured while paying via cheque",
      );
    }
  },
);

// Payment to book the campaigns
export const updateStripeCardPayments = createAsyncThunk(
  "stripe-card-payments",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.STRIPE_PAYMENTS_CARD,
        payload,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred during purchasing the campaign.",
      );
    }
  },
);

// transfer campaign to another buyer
export const searchBuyerForTransferCampaign = createAsyncThunk(
  "search-buyer-for-transfer",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(
        ENDPOINTS.SEARCH_BUYERS + `/${payload}`,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred during purchasing the campaign.",
      );
    }
  },
);

// transfer campaign to another buyer
export const transferCampaignToBuyer = createAsyncThunk(
  "transfer-campaign-to-buyer",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.TRANSFER_CAMPAIGN_TO_BUYER,
        payload,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred during purchasing the campaign.",
      );
    }
  },
);

// Docu sign initiation

export const docuSignbyBuyer = createAsyncThunk(
  "docu-sign-buyer",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.DOCU_SIGN_BUYER,
        payload,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "An error occurred during docusign initiation.",
      );
    }
  },
);

// Complete docusign

export const docuSignCallback = createAsyncThunk(
  "docu-sign-callback",
  async (envelopeId, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(
        ENDPOINTS.DOCU_SIGN_CALLBACK + `/${envelopeId}`,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || " An error occured while completing docusign",
      );
    }
  },
);

// Refresh to reflect docusign success immediately

export const docusignRefresh = createAsyncThunk(
  "docu-sign-refresh",
  async (envelopeId, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(
        ENDPOINTS.DOCU_SIGN_REFRESH + `/${envelopeId}`,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || " An error occured while completing docusign",
      );
    }
  },
);

// Delete multiple products from campaign

export const deleteMultipleProducts = createAsyncThunk(
  "delete-multiple-products",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.DELETE_MULTIPLE_PRODUCTS,
        payload,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred during deleting the products.",
      );
    }
  },
);
export const createProductHoldRequest = createAsyncThunk(
  "hold-request",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.CREATE_HOLD_REQUEST,
        payload,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "An error occurred while creating hold request",
      );
    }
  },
);
//move product to camapign
export const moveProductToCampaign = createAsyncThunk(
  "move-product-to-campaign",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.MOVE_PRODUCT_TO_CAMPAIGN,
        payload,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while moving the product to campaign",
      );
    }
  },
);

// default booking terms status
export const defaultTermsBookingStatus = createAsyncThunk(
  "default-terms-booking-status",

  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.DEFAULT_TERMS_BOOKING_STATUS,
        payload,
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while checking default booking terms",
      );
    }
  },
);
// select campaign and create new campaign post
export const createInstantCampaign = createAsyncThunk(
  "create-instant-campaign",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.CREATE_INSTANT_CAMPAIGN,
        payload,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "An error occurred while creating campaign ",
      );
    }
  },
);
export const getRfpRefreshedCamapignProducts = createAsyncThunk(
  "rfp-refreshed-products",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.get(
        ENDPOINTS.GET_RFP_REFRESHED_CAMPAIGN_PRODUCTS + `/${payload}`,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while fetching the rfp products!",
      );
    }
  },
);
